import React from 'react';
import Container from '../ui/Container';
import Card from '../ui/Card';
import { Star, Quote } from 'lucide-react';

const testimonials = [
  {
    name: "Sarah Johnson",
    role: "Computer Science Student",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80",
    content: "AcademiaHub transformed my learning experience. The one-on-one sessions helped me grasp complex programming concepts easily.",
    rating: 5
  },
  {
    name: "Michael Chen",
    role: "High School Student",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80",
    content: "The flexibility and quality of teachers here are unmatched. I've improved my grades significantly.",
    rating: 5
  },
  {
    name: "Emily Rodriguez",
    role: "Language Learner",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80",
    content: "Found an amazing Spanish teacher here. The personalized attention has helped me become fluent faster.",
    rating: 5
  }
];

const TestimonialSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <Container>
        <div className="text-center mb-16 ">
          <h2 className="text-4xl font-bold mb-6">What Our Students Say</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Join thousands of satisfied students who have transformed their learning journey with AcademiaHub
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 cursor-pointer">
          {testimonials.map((testimonial, index) => (
            <Card key={index} hover className="p-8">
              <div className="flex items-start mb-6">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <h3 className="font-semibold text-lg">{testimonial.name}</h3>
                  <p className="text-gray-600">{testimonial.role}</p>
                </div>
              </div>
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              <div className="relative">
                <Quote className="w-8 h-8 text-indigo-100 absolute -top-4 -left-4" />
                <p className="text-gray-700 leading-relaxed">{testimonial.content}</p>
              </div>
            </Card>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default TestimonialSection;